<footer class="w-full bg-white">
  <div class="mx-[18%] pt-17 pb-10">
    <div class="flex flex-col md:flex-row justify-between items-start gap-8">
      <div class="shrink-0">
        <img src="images/logo.svg" alt="Seiza Logo" class="w-36 h-auto" />
      </div>

      <div class="flex flex-col gap-4">
        <div class="flex items-center justify-between">
          <h3 class="text-th-dark-blue font-inter font-bold text-xl">Contacto</h3>
          <a
            href="https://www.linkedin.com/company/seiza-spa/"
            target="_blank"
            rel="noopener noreferrer"
            class="hover:opacity-80 transition-opacity"
            aria-label="LinkedIn"
          >
            <img src="icons/linkedin_icon.svg" alt="LinkedIn" class="w-6 h-6" />
          </a>
        </div>
        <div class="flex flex-col gap-2 text-th-dark-blue font-inter text-base">
          <a href="mailto:contacto@seiza-ti.cl" class="hover:underline">contacto&#64;seiza-ti.cl</a>
          <a href="tel:+56232242761" class="hover:underline">+56 2 32242761</a>
          <p>Merced 838-A Of. 117 - Santiago, Chile</p>
        </div>
      </div>
    </div>

    <!-- Copyright -->
    <div class="mt-8 pt-6">
      <p
        class="text-th-black text-base leading-relaxed flex-wrap py-2 hover:font-bold cursor-pointer"
      >
        <a
          href="https://seiza-ti.cl/"
          target="_blank"
          rel="noopener noreferrer"
          class="flex items-center gap-1"
        >
          Desarrollado con
          <span class="inline-flex items-center">
            <img src="icons/heart_icon.svg" alt="Heart" class="w-6 h-6" />
          </span>
          por Seiza. Todos los derechos reservados.
        </a>
      </p>
    </div>
  </div>
</footer>
